export type DownloadBlobParams = {
  blob: Blob;
  filename?: string | null;
  fallbackFilename?: string;
};

const INVALID_FILENAME_CHARACTERS = /[\\/:*?"<>|]+/g;
const DEFAULT_FILENAME = 'download';

const sanitizeFilename = (value?: string | null, fallback?: string) => {
  const base = value && value.trim() ? value : fallback;
  if (!base) return DEFAULT_FILENAME;
  return base.replace(INVALID_FILENAME_CHARACTERS, '_') || DEFAULT_FILENAME;
};

export function downloadBlob({ blob, filename, fallbackFilename }: DownloadBlobParams) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const finalFilename = sanitizeFilename(filename, fallbackFilename);
  const objectUrl = window.URL.createObjectURL(blob);

  try {
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = finalFilename;
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  } finally {
    window.URL.revokeObjectURL(objectUrl);
  }
}
